<template>
    <section :class="$mq.phone ? '' :'container'">
        <b-img-lazy id="top-content" src="/static/img/campaign/cleanStoryChallenge/clean_stoy_mix_cover.png" class="img-fluid" alt=""></b-img-lazy>
        <div :class="$mq.phone ? 'container' :''">
            <div id="description">
               <div class="row mt-3">
                    <div class="col-11 col-md-11 p-0 ">
                        <h3 class="text-success">รายละเอียดกิจกรรม Clean Story Challenge</h3>
                    </div>
                    <div class="col-1 col-md-1 p-0">
                        <a class="btn btn-sm" href="#input-content">
                            <i class="fas fa-arrow-down"></i>
                        </a>
                    </div>
               </div>
               <div class="row">
                    <div v-for="item,index in details" :key="index">
                        <h3 class="text-primary mt-3">{{ item.topic }}</h3>
                        <template v-if="item.type_content === 'text'">
                            <span v-html="item.contents"></span>
                        </template>
                        <template v-else>
                            <ol>
                                <li v-for="content in item.contents" style="margin-left: 20px;" v-html="content"></li>
                            </ol>
                        </template>
                    </div>
               </div>
            </div>
            <div id="input-content">
              <div class="row mt-3">
                <div class="col-12 col-md-6 form-group text-center example-snap">
                  <div class="card">
                    <div class="card-header text-center">
                      <h3 style="margin: 0;">ตัวอย่าง การอัพโหลดรูป</h3>
                    </div>
                    <div class="card-body text-center">
                      <b-img-lazy src="/static/img/campaign/cleanStoryChallenge/ex_clean_story_challenge_3.png" class="img-fluid" alt=""></b-img-lazy>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <b-form @submit.prevent="submit" data-vv-scope="form-cleanStoryChallenge">
                    <div class="row mt-3">
                      <div class="col-12 col-md-12 form-group">
                        <label for="tel">เบอร์โทร<span class="text-danger">*</span></label>
                        <b-form-input
                          class="form-control"
                          id="tel"
                          type="tel"
                          :state="state"
                          placeholder="เบอร์โทร (กรอกเฉพาะตัวเลขและพิมพ์ติดกัน)"
                          v-model="formReview.tel"
                          required
                          aria-describedby="input-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-live-feedback">
                          กรุณากรอกเบอร์โทรศัพท์
                        </b-form-invalid-feedback>
                      </div>
                      <div class="col-12 col-md-12 form-group">
                        <label for="link-review">Link Post คุณลูกค้า<span class="text-danger">*</span></label>
                        <b-form-input id="link-review" type="text" class="form-control" v-model="formReview.url_review" placeholder="" :state="stateUrl" required aria-describedby="input-live-feedback-url-review"></b-form-input>
                        <b-form-invalid-feedback id="input-live-feedback-url-review">
                          กรุณากรอก Link Post
                        </b-form-invalid-feedback>
                      </div>
                      <!-- <div class="col-12 col-md-12 form-group">
                        <label for="order-code">รหัสการจอง (optional)</label>
                        <b-form-input id="order-code" type="text" class="form-control" v-model="formReview.order_code"></b-form-input>
                      </div> -->
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <picture-input
                          ref="pictureInput"
                          width="300"
                          height="200"
                          accept="image/jpeg,image/png,image/gif,image/svg,image/webp"
                          size="5"
                          :removable="true"
                          :customStrings="{
                                  upload: '<p>อัพโหลดเรียบร้อย</p>',
                                  drag: 'อัพโหลดรูป',
                                  tap: 'อัพโหลดรูป',
                                  change: 'เปลี่ยนรูป',
                                  remove: 'ลบรูป',
                              }"
                          :zIndex="1000"
                          @change="onChange"
                          @remove="onRemove"
                        ></picture-input>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12">
                        <div class="mb-3 mt-5">
                          <div class="form-group">
                            <button type="submit" class="btn btn-block btn-info" :disabled="isSubmitting">
                              {{ isSubmitting ? 'กำลังส่งรีวิว...' : 'ส่งรีวิว' }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                  </b-form>
                </div>

              </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios'
import PictureInput from 'vue-picture-input'

export default {
  components: {
    PictureInput
  },
  data: () => ({
    details: [
      {
        topic: '1. คุณสมบัติผู้เข้าร่วมกิจกรรม',
        type_content: 'text',
        contents: '<span>ไม่จำกัดเพศ โดยถ่ายวีดิโอคอนเท้นต์เนื้อหาเกี่ยวกับผู้สูงอายุหรือเนื้อหาเกี่ยวกับสัตว์เลี้ยง ในหัวข้อ <span class="font-weight-bold">“ทำไมต้องใช้บริการคุณแม่บ้าน BeNeat” หรือ “รีวิวคุณแม่บ้าน BeNeat”</span></span>'
      },
      {
        topic: '2. กติกาการเข้าร่วมกิจกรรม',
        type_content: 'ol',
        contents: [
          '<span>โพสต์คลิปวีดีโอคู่กับคุณแม่บ้าน BeNeat หรือ สถานที่หลังจากทำความสะอาด <span class="font-weight-bold">ความยาวตั้งแต่ 1 นาทีขึ้นไป</span> พร้อมบรรยายถึง <span class="font-weight-bold">“ทำไมต้องใช้บริการคุณแม่บ้าน BeNeat”</span> ลงในช่องทางโซเชียลมีเดียช่องทางใดช่องทางหนึ่ง เช่น <span class="font-weight-bold">Facebook Instagram และ TikTok</span> </span>',
          '<span>ใส่ <span class="font-weight-bold">#CleanStoryChallenge</span> ลงในโพสต์ของท่าน และเปิดโพสต์เป็นสถานะ <span class="font-weight-bold">"สาธารณะ"</span> เพื่อให้ทีมงานสามารถเข้าไปดูได้ </span>',
          '<span>ภายในคลิปวีดิโอ จะต้องมี Logo หรือ ข้อความ ที่แสดงถึง BeNeat ปรากฏภายในคลิปวีดิโอ</span>',
          '<span>ผู้เข้าร่วมกิจกรรมจะต้องอัพโหลดรูปหลักฐานการโพสต์ (Screenshot) พร้อมแนบลิงค์โพสต์</span>'
        ]
      },
      {
        topic: '3. ระยะเวลากิจกรรม',
        type_content: 'ol',
        contents: [
          '<span>เข้าร่วมกิจกรรมระหว่าง<span class="font-weight-bold">วันที่ 11 มกราคม - 29 กุมภาพันธ์ 2567</span></span>',
          '<span>ประกาศผลผู้ได้รับรางวัล 3 อันดับแรก จำนวน 6 ท่าน และผู้ได้รับรางวัลชมเชยใน <span class="font-weight-bold">วันที่ 8 มีนาคม 2567 เวลา 13.00 น.</span> ทาง Facebook Page: BeNeat : แม่บ้านออนไลน์</span>'
        ]
      },
      {
        topic: '4. เกณฑ์การตัดสิน',
        type_content: 'ol',
        contents: [
          '<span>ตัดสินจาก <span class="font-weight-bold">Top Engagement จำนวนการกด Shares และยอด Views มากที่สุด 3 อันดับ</span> (สายละ 3 อันดับ)</span>',
          '<span>ต้องเป็นผู้ที่ทำถูกกติกาการเข้าร่วมกิจกรรมในข้อ 2 ครบทุกข้อ</span>'
        ]
      },
      {
        topic: '5. ของรางวัลและเงื่อนไขการรับรางวัล',
        type_content: 'ol',
        contents: [
          '<span>อันดับที่ 1 จากทั้ง 2 หัวข้อ จะได้รับเงินรางวัล มูลค่า <span class="font-weight-bold">10,000 บาท</span> (ก่อนหัก ณ ที่จ่าย) </span>',
          '<span>อันดับที่ 2 จากทั้ง 2 หัวข้อ จะได้รับเงินรางวัล มูลค่า <span class="font-weight-bold">5,000 บาท</span> (ก่อนหัก ณ ที่จ่าย) </span>',
          '<span>อันดับที่ 3 จากทั้ง 2 หัวข้อ จะได้รับเงินรางวัล มูลค่า <span class="font-weight-bold">3,000 บาท</span> (ก่อนหัก ณ ที่จ่าย) </span>',
          '<span>ผู้เข้าร่วมท่านอื่น ๆ จะได้รับรางวัลชมเชย <span class="font-weight-bold">"บริการทำความสะอาดทั่วไป ฟรี! 2 ชั่วโมง"</span></span>'
        ]
      },
      {
        topic: '6. เงื่อนไขอื่น ๆ',
        type_content: 'ol',
        contents: [
          '<span>ในกรณีที่ผู้เข้าร่วมกิจกรรมทำการคัดลอกหรือปลอมแปลงข้อความเพื่อเข้าร่วมเล่นกิจกรรม หากคณะกรรมการตรวจสอบแล้วพบข้อมูลเท็จ ขอตัดสิทธิ์การร่วมกิจกรรมในทุกกรณี</span>',
          '<span>การตัดสินของคณะกรรมการถือเป็นที่สิ้นสุด และขอสงวนสิทธิ์ในการเปลี่ยนแปลงเงื่อนไขและกติกาโดยไม่ต้องแจ้งให้ทราบล่วงหน้า</span>',
          '<span>ทาง BeNeat จะมีการนำเนื้อหา และวีดีโอ ของผู้เข้าร่วมกิจกรรม มาทำคอนเทนต์ประชาสัมพันธ์ โดยไม่มีการขออนุญาตหรือจ่ายค่าตอบแทนเพิ่มเติม และไม่มีการลบโพสต์</span>',
          '<span>ผู้ได้รับรางวัลมูลค่า 1,000 บาทขึ้นไป ต้องชำระภาษีรางวัลชิงโชคหัก ณ ที่จ่ายจำนวน 5% ของมูลค่าของรางวัล</span>'
        ]
      }
    ],
    isSubmitting: false,
    formReview: {
      img_review: null,
      tel: null,
      order_code: null,
      url_review: null
    },
    state: null,
    stateUrl: null
  }),
  watch: {
    'formReview.tel': function (n, o) {
      if (n) {
        this.state = null
      }
    }
  },
  methods: {
    onChange (image) {
      if (image) {
        this.formReview.img_review = image
      } else {
        this.onRemove()
      }
    },
    onRemove () {
      this.formReview.img_review = null
    },
    submit () {
      this.$validator.validateAll('form-cleanStoryChallenge').then(async (valid) => {
        if (valid) {
          /* check upload img review */
          if (!this.formReview.img_review) {
            this.$swal('ข้อมูลไม่ครบถ้วน', 'กรุณาอัปโหลดรูปภาพ', 'error')
            return
          }
          /* checko tel number */
          const rex = /^\+?[0-9-]+$/
          let phone = this.formReview.tel
          if (phone) {
            let valid = phone.match(rex)
            if (!valid) {
              this.state = false
            } else {
              this.state = false
              if (phone.length >= 10 && phone.length <= 15) {
                let phoneValid = phone.match(rex)
                if (phoneValid) {
                  this.state = true
                }
              }
            }
          } else {
            this.state = false
          }
          if (this.formReview.url_review) {
            const rex = /.*\/(.*)\/(.*)$/
            let url = this.formReview.url_review
            if (url.match(rex)) {
              this.stateUrl = true
            } else {
              this.stateUrl = false
            }
          } else {
            this.stateUrl = false
          }
          /* breck event if tel number state false */
          if (!this.state || !this.stateUrl) return
          /* api input */
          let formData = new FormData()
          formData.append('img_review', this.formReview.img_review)
          formData.append('tel', this.formReview.tel)
          if (this.formReview.order_code) {
            formData.append('order_code', this.formReview.order_code)
          }
          if (this.formReview.url_review) {
            formData.append('url_review', this.formReview.url_review)
          }
          const url = '/marketing-campaign'
          try {
            this.isSubmitting = true // loading active
            const { data } = await axios.post(url, formData)
            if (!data.error) {
              this.initForm()
              this.$swal('ส่งรีวิวสำเร็จ', '', 'success')
            } else {
              this.isSubmitting = false
            }
          } catch (error) {
            this.isSubmitting = false
          }
        }
      })
    },
    async initForm () {
      this.isSubmitting = false
      this.state = null
      this.stateUrl = null
      this.formReview.img_review = null
      this.formReview.tel = null
      this.formReview.order_code = null
      this.formReview.url_review = null
      if (this.$refs.pictureInput) {
        this.$refs.pictureInput.removeImage()
      }
    }
  },
  created () {
    this.initForm()
  }
}
</script>
<style lang="scss" scoped>
@import "~bootstrap/scss/_functions.scss";
@import "~bootstrap/scss/_variables.scss";
@import "~bootstrap/scss/mixins/breakpoints";
html {
  scroll-behavior: smooth;
}
.text-style {
  color: #3bbcd4;
}

.sub-text-style {
  text-shadow: -2px 2px 1px #ebebeb;
  color: #00bcd4;
  font-weight: 500;
}

.shiny-text {
  text-shadow: -2px 2px 1px #3bbcd4;
  color: #fff;
  font-weight: 500;
}

div.example-snap {
  padding: 15px;
}


@include media-breakpoint-down(md) {
  span.sub-text-style {
    font-size: 1.5rem;
  }
}

@include media-breakpoint-up(lg) {
  div.example-snap {
    padding: 0 100px 100px 100px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/campaign/cleanStoryChallenge/index.vue